<template>
  <div id="main-box" class="page-content">
    <div class="home-box">
      <div class="swiper-container home-hint">
        <div class="swiper-wrapper">
          <div class="swiper-slide notice-row" v-for="item in notice" v-text="item"></div>
        </div>
      </div>

      <div class="nav-box">
        <ul class="nav-main" v-for="(item,index) in navlist" v-on:click="OpenPage('MemberOrder',item.id)">
          <li class="nav-main-icon"><i class="fa" :class="item.icon"></i></li>
          <li class="nav-main-right">
            <p v-text="item.name"></p>
            <p v-text="item.count"></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="chart-box" style="margin-top: 20px;">
      <div class="chart-box-row" id="OrdProChart"></div>
      <div class="chart-box-row" id="GloProChart"></div>
    </div>

    <div class="chart-box">
      <div style="width: 100%;margin: 0;" class="chart-box-row" id="ColChart"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>


  </div>
</template>

<script>
  var self, ColChart, OrdProChart, GloProChart;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  export default {
    name: 'ProHomePage',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
    },
    data() {
      return {
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        notice:[
          "2021年9月20日起，续重运费将从0.5元/kg，调整为1元/kg，感谢您的支持，祝商祺！",
          "ExShopee上架功能开启，点击上方导航 “上架” 按钮，免费使用吧！",
          "新用户注册可免费获赠5积分！",
        ],
        hint: "系统提示： 新用户注册可免费获赠5积分！",
        isLogin: true,
        money: 0,
        navlist: [{
          id: 1,
          count: 0,
          icon: "fa-cloud",
          name: "采集总数"
        }, {
          id: 2,
          count: 0,
          icon: "fa-star",
          name: "普通上架数"
        }, {
          id: 3,
          count: 0,
          icon: "fa-cloud-upload",
          name: "全球上架数"
        }, {
          id: 4,
          count: 0,
          icon: "fa-exclamation-circle",
          name: "用户总数"
        }, {
          id: 5,
          count: 0,
          icon: "fa-hashtag",
          name: "店铺总数"
        }],
        orders: []
      }
    },
    mounted() {
      self = this;
      self.GetDatas();

      //屏幕宽度改变图表自动适应
      window.addEventListener('resize', function() {
        self.ChangeChartWidth();
      })

      //滚动公告
      var mySwiper = new Swiper('.swiper-container', {
      	autoplay: {
          delay: 3000,
        },
      	loop: true,
        direction: 'vertical',
      })

    },
    methods: {
      ColLine(datas) {
        // 基于准备好的dom，初始化echarts实例
        ColChart = self.$echarts.init(document.getElementById('ColChart'))
        var numlist = datas.count
        var datelist = datas.date;

        let option = {
          title: {
            top: 20,
            left: 20,
            text: '采集列表',
            subtext: 'Collection list'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: 90,
            left: 55,
            bottom: 30,
            right: 40,
            borderColor: "#F00"
          },
          xAxis: {
            type: 'category',
            data: datelist,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: ['rgba(128, 128, 128,0.6)'],
              }
            }
          },
          series: [{
            data: numlist,
            type: 'bar',
            barWidth : 80,
            itemStyle: {
              color: "#65bdf8",
              borderWidth: 3
            }
          }]
        };

        // 绘制图表
        ColChart.setOption(option);
      },
      OrdProLine(datas) {
        // 基于准备好的dom，初始化echarts实例
        OrdProChart = self.$echarts.init(document.getElementById('OrdProChart'))
        var numlist = datas.count
        var datelist = datas.date;

        let option = {
          title: {
            top: 20,
            left: 20,
            text: '普通商品上架',
            subtext: 'General merchandise on the shelves'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: 90,
            left: 55,
            bottom: 30,
            right: 40,
            borderColor: "#F00"
          },
          xAxis: {
            type: 'category',
            data: datelist,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: ['rgba(128, 128, 128,0.6)'],
              }
            }
          },
          series: [{
            data: numlist,
            type: 'line',
            symbolSize: 10,
            itemStyle: {
              color: "#65bdf8",
              borderWidth: 3
            }
          }]
        };

        // 绘制图表
        OrdProChart.setOption(option);
      },
      GloProLine(datas) {
        // 基于准备好的dom，初始化echarts实例
        GloProChart = self.$echarts.init(document.getElementById('GloProChart'))
        var numlist = datas.count
        var datelist = datas.date;

        let option = {
          title: {
            top: 20,
            left: 20,
            text: '全球商品上架',
            subtext: 'Global merchandise on the shelves'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: 90,
            left: 55,
            bottom: 30,
            right: 40,
            borderColor: "#F00"
          },
          xAxis: {
            type: 'category',
            data: datelist,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: ['rgba(128, 128, 128,0.6)'],
              }
            }
          },
          series: [{
            data: numlist,
            type: 'line',
            symbolSize: 10,
            itemStyle: {
              color: "#65bdf8",
              borderWidth: 3
            }
          }]
        };

        // 绘制图表
        GloProChart.setOption(option);
      },
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetDatas() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_admin_product_static/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var json = datas;
            var navlist = self.navlist;
            for (let item in navlist) {
              navlist[item].count = json.count_arr[item]
            }
            self.navlist = navlist;

            if(json.list.length > 0){
              self.ColLine(json.list[0]);
            }
            if(json.list.length > 1){
              self.OrdProLine(json.list[1]);
            }
            if(json.list.length > 2){
              self.GloProLine(json.list[2]);
            }
          });

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      OpenPage(url, data) {
        localStorage.setItem("ExShopee_HistoryURL", url);
        if (data) {
          self.GoToPage('/' + url + '?te=' + data); // 路由跳转
        } else {
          self.GoToPage('/' + url); // 路由跳转
        }
      },
      ChangeChartWidth() {
        ColChart.resize();
        OrdProChart.resize();
        GloProChart.resize();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-box {
    padding: 20px 20px 0 20px;
  }

  .nav-box {
    overflow: hidden;
  }

  .nav-main {
    float: left;
    width: calc(18.39% - 40px);
    background-color: #33cabb;
    margin-right: 2%;
    padding: 30px 20px;
    ;
    cursor: pointer;
    border-radius: 5px;
  }

  .nav-main:hover {
    opacity: 0.9;
  }

  .nav-main:last-child {
    margin-right: 0%;
  }

  .nav-main-icon {
    display: inline-block;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    color: #FFF;
    float: left;
    text-align: center;
    font-size: 1.5em;
    line-height: 48px;
    background-color: rgba(255, 255, 255, 0.175);
  }

  .nav-main-icon img {
    display: table;
    width: 100%;
  }

  .nav-main-left {
    float: left;
  }

  .nav-main-right {
    float: right;
    color: #FFF;
  }

  .nav-main-right p:first-child {
    font-size: 14px;
  }

  .nav-main-right p:last-child {
    font-size: 2em;
    margin-top: 10px;
    text-align: center;
  }

  .nav-main:nth-child(1) {
    background-color: #33cabb;
  }

  .nav-main:nth-child(2) {
    background-color: #65bdf8;
  }

  .nav-main:nth-child(3) {
    background-color: #15c377;
  }

  .nav-main:nth-child(4) {
    background-color: #f96868;
  }

  .nav-main:nth-child(5) {
    background-color: #926dde;
  }

  .home-mian {
    overflow: hidden;
  }

  .home-mian-left {
    width: 230px;
    float: left;
    margin: 20px 0 20px 20px;
  }

  .home-mian-right {
    float: left;
    overflow: hidden;
    width: calc(100% - 290px);
    padding: 20px;
  }

  .home-mian-row {
    height: 210px;
    border-radius: 5px;
    background-color: #FFF;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }

  .home-main-title {
    font-size: 15px;
    color: #666;
    padding: 15px 20px;
  }

  .home-main-count {
    text-align: center;
    font-size: 2em;
    margin: 30px 0;
    color: #f60;
  }

  .home-main-btnArr {
    overflow: hidden;
    display: table;
    margin: 0 auto;
    margin-bottom: 20px;

  }

  .home-main-btnArr a {
    float: left;
    display: table;
    padding: 10px 15px;
    margin-right: 10px;
    border-radius: 5px;
    border: 1px solid #EEE;
    cursor: pointer;
  }

  .home-main-btnArr a:hover {
    color: #000;
    background-color: #F9F9F9;
  }

  .home-mian-right-contact {
    float: left;
    width: 49%;
    margin-right: 2%;
  }

  .home-mian-right-address {
    float: left;
    width: 49%;
  }

  .home-mian-right-row {
    padding: 0 25px;
    padding-bottom: 20px;
    border-top: 1px solid #f3f3f3;
  }

  .home-mian-right-row ul li {
    overflow: hidden;
  }

  .home-mian-right-row ul li p {
    float: left;
    margin-top: 11px;
    font-size: 15px;
    line-height: 22px;
    color: #333;
  }

  .home-mian-right-row ul li p:first-child {
    width: 70px;
  }

  .home-mian-right-row ul li p:last-child {
    width: calc(100% - 70px);
  }

  .home-mian-right-row a {
    display: table;
    padding: 1px 3px;
    border-radius: 50px;
    color: #fff;
    background: rgba(101, 189, 248, 0.8)
  }

  .home-mian-right-contact-box ul li p:first-child {
    width: 53px;
  }

  .chart-box {
    overflow: hidden;
    position: relative;
    padding: 0 20px 20px 20px;
  }

  .chart-box-row {
    width: 49%;
    float: left;
    height: 350px;
    border-radius: 5px;
    background-color: #FFF;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }

  .chart-box-row:last-child {
    margin-left: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/product/ProHomePage.vue